import React, {useState, useEffect} from 'react';
import { Dropdown } from 'react-bootstrap';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectUser, selectUserID } from '../../redux/user/user-selector';
import {withRouter} from "react-router-dom";
import TaskCreationPopup from '../../pages/tasks/scenes/task-creation-popup/task-creation-popup';
import TaskCreateDocumentModal from '../../pages/tasks/scenes/task-create-document-modal';
import NoPermissionsPanel from '../no-permissions-panel/no-permissions-panel';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FluentUiIcon from '../../assets/fluent-ui-icon';
import './create-button-universal.scss';

const CreateButton = ({user, history, userID}) => {

    const [permittedDropDownItems,setPermittedDropDownItems] = useState([]);
    const [showTaskPopup, setShowTaskPopup] = useState(false);
    const [showNoPermissions, setShowNoPermissions] = useState(false);
    const [noPermissionsMessage, setNoPermissionsMessage] = useState('');

    const [showDCTaskModal, setShowDCTaskModal] = useState(false);
    const labels = user?.objectLabels;
    const dropdownItemData = [
        {
         label: labels?.ProjectSingular ?? "Project",
         idName: "project-icon",
         fluentIcon: "FolderRegular",
         privilegeName: "Project"
        },
        {
         label: labels?.TaskSingular ?? "Task",
         idName: "task-icon",
         fluentIcon: "ClipboardTaskRegular",
         privilegeName: "Home"
        },
         {
         label: `${labels?.ProjectSingular ?? "Project"} Template`,
         idName: "template-icon",
         fluentIcon: "CopyRegular",
         privilegeName: "Templates"
        }];

    //Filter off all the create buttons they don't have privileges for
    useEffect(() => {
        let permitted = dropdownItemData.filter(({privilegeName}) => {
            if(!user.privileges.hasOwnProperty(privilegeName)){
                return false;
            }
            return user.privileges[privilegeName].Add;
        });

        setPermittedDropDownItems(permitted);
    },[])

    const getOnClick = (labelName) => {
        switch(labelName){
            case "Project":
                pushHistory("/projects/create");
                return;
            case "Task":
                setShowTaskPopup(true);
                if (window.location.href.includes("tasks")) {
                    setShowTaskPopup(true);
                // doing the same but routing help us to have overlay tasks in the background
                } else {
                    setShowTaskPopup(false);
                    pushHistory({
                        pathname: "/tasks",
                        state: { showTaskCreationPopup: true }
                    });
                }
                return;
            case "Project Template":
                pushHistory("/admin/templates/create");
                return;
            default:
                return;
        }
    }

    const pushHistory = (link) =>{
        history.push(link);
    }

    const handleNoTaskPermissions = (message) => {
        setShowNoPermissions(true);
        setNoPermissionsMessage(message);
    }

    const onShowDCTask = () => {
        setShowDCTaskModal(true);
        setShowTaskPopup(false);
    }
    const onHideDCTask = () => {
        setShowDCTaskModal(false);
    }

    return(
        <div className = "universal-create-button-section">
            {
                showTaskPopup &&
                <TaskCreationPopup
                        show={showTaskPopup}
                        onHide={() => {setShowTaskPopup(false);}}
                        onShowDCTask={()=> onShowDCTask()}
                        privileges = {user.privileges}
                        userID ={userID}
                        handlePermissions={handleNoTaskPermissions}/>
            }
            {
                showDCTaskModal &&
                <TaskCreateDocumentModal
                    show={showDCTaskModal}
                    onHide={() => onHideDCTask()}
                    projectId={null}
                    privileges={user.privileges}
                />
            }
            {
                showNoPermissions &&
                    <NoPermissionsPanel
                        show={showNoPermissions}
                        onHide={() => {setShowNoPermissions(false)}}
                        message={noPermissionsMessage}/>
            }
            <Dropdown style={{ cursor:"default" }} >

            {
                (permittedDropDownItems.length <= 0) ?
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 150, hide: 150 }}
                    overlay={
                        <Tooltip id="button-tooltip" className= "disabled-tooltip">
                            {`Your current Role does not allow you to Create ${labels.ProjectPlural ?? "Projects"}, ${labels.TaskPlural ?? "Tasks"} and Templates. Reach out to your TRIYO Administrator or Account Manager to get access.`}
                        </Tooltip>
                    }
                >
                    <div>
                        <Dropdown.Toggle
                            className = "create-button"
                            disabled = {true}>
                            <FluentUiIcon name="AddRegular" size={20} color="#616161" />
                        </Dropdown.Toggle>
                    </div>
                </OverlayTrigger> :
                <Dropdown.Toggle
                    className = "create-button">
                    <FluentUiIcon name="AddRegular" size={20} color="#616161" />
                </Dropdown.Toggle>
            }
                <Dropdown.Menu className="edit-dropdown-menu-container">

                    {
                        permittedDropDownItems.map(({label, fluentIcon}, index) =>{
                            return(
                                <React.Fragment key={index}>
                                    <Dropdown.Item
                                        className="edit-dropdown-menu-item"
                                        onClick = {() => {getOnClick(label)}}
                                        key= {index}
                                    >
                                        <span className="edit-dropdown-menu-item-name">
                                            <FluentUiIcon name={fluentIcon} size={16} color="#242424" />
                                            <div className="create-text">{label}</div>
                                        </span>

                                    </Dropdown.Item>
                                </React.Fragment>
                            );
                        })
                    }
                    {
                        dropdownItemData
                            .filter(({privilegeName}) => {
                                if (!user.privileges.hasOwnProperty(privilegeName)) return false;
                                return !user.privileges[privilegeName].Add;
                            })
                            .map(({label, fluentIcon}, index) => (
                                <React.Fragment key={`disabled-${index}`}>
                                    <Dropdown.Item
                                        className="edit-dropdown-menu-item edit-dropdown-menu-item--disabled"
                                        disabled={true}
                                        key={`disabled-${index}`}
                                    >
                                        <span className="edit-dropdown-menu-item-name">
                                            <FluentUiIcon name={fluentIcon} size={16} color="#BDBDBD" disabled={true} />
                                            <div className="create-text create-text--disabled">{label}</div>
                                        </span>
                                    </Dropdown.Item>
                                </React.Fragment>
                            ))
                    }

                </Dropdown.Menu>
            </Dropdown>
        </div>

    )
}

const mapState = createStructuredSelector({
    user: selectUser,
    userID: selectUserID
})

export default withRouter(connect(mapState, null)(CreateButton));